/* eslint-disable react/self-closing-comp */
import React from 'react'
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'

import Auth from 'App/Auth/AuthProvider/AuthProvider'

import I18nLocaleProvider from '../shared/I18nLocaleProvider'

import {
    StyledErrorBoundary,
    ErrorBoundary,
} from './ErrorBoundaries'
import Root from './Root'
import authRoles from './authRoles'
// import StylesProvider from './StylesProvider'
import AccessProvider from './AccessProvider'
import ThemeProvider from './ThemeProvider'

import './App.css'

const allowedRoles = [
    authRoles.ADMIN,
    authRoles.USER,
]

const queryClient = new QueryClient({ defaultOptions: { queries: {
    staleTime: 10000,
    cacheTime: 10000,
} } })

function App() {
    return (
        <ErrorBoundary>
            <Auth>
                <ThemeProvider>
                    <I18nLocaleProvider>
                        <StyledErrorBoundary>
                            <QueryClientProvider client={queryClient}>
                                <AccessProvider allowedRoles={allowedRoles}>
                                    <Root />
                                </AccessProvider>
                            </QueryClientProvider>
                        </StyledErrorBoundary>
                    </I18nLocaleProvider>
                </ThemeProvider>
            </Auth>
        </ErrorBoundary>
    )
}

export default App
